import React from "react";
import {
  DashboardTitle,
  DefaultDashboardTitle,
} from "../../../Utils/Constants";

import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
import { Col, Container, Row } from "reactstrap";
import WelcomeBanner from "./WelcomeBanner";
import EarningCard from "./EarningCard";
import JobCard from "./JobCard";
import TransitionHistory from "./TransitionHistory";
import TotalInvestment from "../../../Utils/CommonComponents/CommonDashboard/CommonDefault/TotalInvestment";
import { investmentChart } from "../../../Data/Dashboard/Default";
import TopUsers from "./TopUsers";

import { ToastContainer } from "react-toastify";

export default function DefaultDashboard() {
  return (
    <>
      <Breadcrumbs
        pageTitle={DefaultDashboardTitle}
        parent={DashboardTitle}
        title={DefaultDashboardTitle}
        paragraph='"Welcome back! Let’s continue."'
      />
      <Container className="default-dashboard" fluid>
        <Row className="g-3">
          <WelcomeBanner colClass="col-xxl-3 col-xl-4 col-lg-4 col-md-4 col-sm-12" />
          <JobCard colClass="col-xxl-6 col-xl-8 col-lg-8 col-md-8 col-sm-12" />
          <EarningCard colClass="col-xxl-3 col-xl-5 col-lg-5 col-md-5 col-sm-12" />
          <TopUsers colClass="col-xxl-4 col-xl-7 col-lg-7 col-md-7 col-sm-12" />
          <TotalInvestment
            colClass="col-xxl-3 col-xl-5 col-lg-5 col-md-5 col-sm-12"
            chartData={investmentChart}
            height={350}
            investmentList
          />
          <TransitionHistory colClass="col-xxl-5 col-xl-7 col-lg-7 col-md-7 col-sm-12" />
        </Row>
      </Container>
      <ToastContainer/>
    </>
  );
}


